/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const deleteUsersPreferencesUnitsUnitidPathUnitIdSchema = z.string()

export const deleteUsersPreferencesUnitsUnitidStatus204Schema = z.string()

export const deleteUsersPreferencesUnitsUnitidStatus400Schema = z.string()

export const deleteUsersPreferencesUnitsUnitidStatus401Schema = z.string()

export const deleteUsersPreferencesUnitsUnitidStatus404Schema = z.string()

export const deleteUsersPreferencesUnitsUnitidStatus500Schema = z.string()

export const deleteUsersPreferencesUnitsUnitidResponseSchema = deleteUsersPreferencesUnitsUnitidStatus204Schema

export const deleteUsersPreferencesUnitsUnitidErrorSchema = z.union([deleteUsersPreferencesUnitsUnitidStatus400Schema, deleteUsersPreferencesUnitsUnitidStatus401Schema, deleteUsersPreferencesUnitsUnitidStatus404Schema, deleteUsersPreferencesUnitsUnitidStatus500Schema])
